<template>
  <div class="header-info header-info--staff">
    <div class="staff-info">
      歡迎回來，{{ CurrectStaffProfile.userName }}
    </div>
    <div class="staff-role">
      <a @click="logout">登出</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const fb = require('@/firebaseConfig.js')

export default {
  computed: {
    ...mapState(['CurrectStaffProfile'])
  },
  methods: {
    logout () {
      fb.auth.signOut().then(() => {
        this.$store.dispatch('clearData')
        this.$router.push('/login')
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .header-info--staff {
    display: flex;
    justify-content: space-between;
    line-height: 3rem;
    height: 3rem;
    font-size: 1.25em;
    background: var(--color-light-blue);
  }
</style>
